import React from 'react'
import styled from 'styled-components';

const CustomStrong = styled.strong`
  color: var(--mainBlue) !important;
`;

export default function Title({name, title}) {
  return (
    <div className="row">
      <div className="column">
        <h1 className="productName">
          {name} <CustomStrong>{title}</CustomStrong>
        </h1>
      </div>
    </div>
  )
}